module.exports = __webpack_public_path__ + "public/images/generated-draw-with-procreate.82747f525da454a5cd73925bb68a8c40.jpg";